// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"3f34dbc7","713":"53969bbc","956":"32c6a5e2"}[chunkId] + ".chunk.js";
};